import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ShieldOff, AlertTriangle, Clock, X } from 'lucide-react';
export function BonusTwo() {
  return <section className="w-full py-16 px-6 border-t" style={{
    backgroundColor: 'var(--light-navy)',
    borderColor: 'white'
  }} data-id="element-333">
      <div className="max-w-2xl mx-auto" data-id="element-334">
        <div className="flex items-center gap-2 mb-8" data-id="element-335">
          <span className="px-3 py-1 rounded text-xs font-bold tracking-wider uppercase" style={{
          backgroundColor: 'var(--navy)',
          color: 'var(--gold)'
        }} data-id="element-336">
            Bono #2
          </span>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8" data-id="element-337">
          <h2 className="font-serif text-3xl md:text-4xl mb-2" style={{
          color: 'var(--navy)'
        }} data-id="element-338">
            "Lista Antitento: 50 Reglas de Compra Impulsiva"
          </h2>
          <p className="text-xl font-medium mb-6" data-id="element-339">
            Valor: <span className="line-through opacity-50" data-id="element-340">$47</span> —{' '}
            <span style={{
            color: 'var(--gold)'
          }} data-id="element-341">
              Tuyo GRATIS
            </span>
          </p>

          <img src="https://cdn.magicpatterns.com/uploads/cDUPbP7AVwRuWJtdYdg7cQ/BONO_2_-_LISTA_ANTITENTO_-_50_REGLAS_DE_COMPRA_IMPULSIVA.png" alt="Lista Antitento: 50 Reglas de Compra Impulsiva" className="w-full rounded-xl shadow-lg mb-8" data-id="element-342" />

          <h3 className="font-bold text-xl mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-343">
            El momento exacto donde todo se decide.
          </h3>
          <p className="text-lg mb-6" style={{
          color: 'var(--charcoal)',
          lineHeight: '1.7'
        }} data-id="element-344">
            Hay un instante — entre el impulso y el clic — que dura menos de 10
            segundos. Si en esos 10 segundos tenés una regla clara y automática,
            el impulso pierde. Si no la tenés, el sistema gana.
          </p>
          <p className="text-lg mb-8" style={{
          color: 'var(--charcoal)',
          lineHeight: '1.7'
        }} data-id="element-345">
            No es falta de inteligencia. Es ingeniería diseñada para vencerte. Y
            la única forma de ganarle es tener tus propias reglas — más rápidas,
            más simples y más automáticas que el impulso.
          </p>
        </motion.div>

        {/* Comparison Table */}
        <div className="mb-10 overflow-x-auto" data-id="element-346">
          <table className="w-full text-left border-collapse min-w-[500px]" data-id="element-347">
            <thead data-id="element-348">
              <tr style={{
              borderBottom: '2px solid rgba(27, 42, 74, 0.1)'
            }} data-id="element-349">
                <th className="py-3 font-bold" style={{
                color: 'var(--navy)'
              }} data-id="element-350">
                  Método típico
                </th>
                <th className="py-3 font-bold" style={{
                color: 'var(--navy)'
              }} data-id="element-351">
                  Por qué falla
                </th>
              </tr>
            </thead>
            <tbody className="text-sm md:text-base" data-id="element-352">
              <tr className="border-b border-gray-200" data-id="element-353">
                <td className="py-3" data-id="element-354">"Voy a tener más autocontrol"</td>
                <td className="py-3 opacity-80" data-id="element-355">
                  Se agota con el cansancio y el estrés
                </td>
              </tr>
              <tr className="border-b border-gray-200" data-id="element-356">
                <td className="py-3" data-id="element-357">"Voy a pensar antes de comprar"</td>
                <td className="py-3 opacity-80" data-id="element-358">
                  En el impulso no hay tiempo para pensar
                </td>
              </tr>
              <tr className="border-b border-gray-200" data-id="element-359">
                <td className="py-3" data-id="element-360">"Voy a hacer un presupuesto"</td>
                <td className="py-3 opacity-80" data-id="element-361">
                  No resuelve el momento del clic
                </td>
              </tr>
              <tr className="border-b border-gray-200" data-id="element-362">
                <td className="py-3" data-id="element-363">"Voy a borrar las apps"</td>
                <td className="py-3 opacity-80" data-id="element-364">
                  El impulso encuentra otro camino
                </td>
              </tr>
              <tr className="font-bold" style={{
              backgroundColor: 'rgba(200, 164, 92, 0.1)'
            }} data-id="element-365">
                <td className="py-3 pl-2" style={{
                color: 'var(--navy)'
              }} data-id="element-366">
                  50 Reglas IF/THEN
                </td>
                <td className="py-3" style={{
                color: 'var(--navy)'
              }} data-id="element-367">
                  Funciona incluso en tu peor día
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="bg-white p-6 rounded-xl mb-10 shadow-sm" data-id="element-368">
          <h4 className="font-bold text-lg mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-369">
            El sistema IF/THEN:
          </h4>
          <p className="mb-4" data-id="element-370">
            En vez de depender de motivación, convertís cada tentación en una
            acción automática:
          </p>

          <div className="space-y-3" data-id="element-371">
            <div className="p-3 rounded bg-gray-50 border-l-4" style={{
            borderColor: 'var(--gold)'
          }} data-id="element-372">
              <span className="font-bold text-xs uppercase tracking-wide opacity-60" data-id="element-373">
                Regla
              </span>
              <p className="font-medium" data-id="element-374">
                IF ves un ad de algo que querés THEN lo guardás en lista y
                esperás 48 horas
              </p>
            </div>
            <div className="p-3 rounded bg-gray-50 border-l-4" style={{
            borderColor: 'var(--gold)'
          }} data-id="element-375">
              <span className="font-bold text-xs uppercase tracking-wide opacity-60" data-id="element-376">
                Regla
              </span>
              <p className="font-medium" data-id="element-377">
                IF querés pedir delivery por estrés THEN tomás agua y esperás 10
                minutos
              </p>
            </div>
            <div className="p-3 rounded bg-gray-50 border-l-4" style={{
            borderColor: 'var(--gold)'
          }} data-id="element-378">
              <span className="font-bold text-xs uppercase tracking-wide opacity-60" data-id="element-379">
                Regla
              </span>
              <p className="font-medium" data-id="element-380">
                IF es una "oferta limitada" THEN te preguntás: ¿lo compraría a
                precio normal?
              </p>
            </div>
          </div>
        </div>

        <div className="mb-8" data-id="element-381">
          <h4 className="font-bold text-lg mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-382">
            Lo que incluye:
          </h4>
          <ul className="space-y-3" data-id="element-383">
            <li className="flex gap-3" data-id="element-384">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-385" />
              <span data-id="element-386">PDF con las 50 reglas completas por categoría</span>
            </li>
            <li className="flex gap-3" data-id="element-387">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-388" />
              <span data-id="element-389">Tarjetas IF/THEN (printable recortable)</span>
            </li>
            <li className="flex gap-3" data-id="element-390">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-391" />
              <span data-id="element-392">5 Wallpapers para celular — frases antitento</span>
            </li>
            <li className="flex gap-3" data-id="element-393">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-394" />
              <span data-id="element-395">Checklist "Antes de comprar" (6 preguntas clave)</span>
            </li>
            <li className="flex gap-3" data-id="element-396">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" style={{
              color: 'var(--green)'
            }} data-id="element-397" />
              <span data-id="element-398">Guión de 3 frases para salir del impulso sin culpa</span>
            </li>
          </ul>
        </div>

        <div className="p-6 rounded-xl border border-dashed border-gray-300 bg-white" data-id="element-399">
          <p className="font-medium text-center" style={{
          color: 'var(--navy)'
        }} data-id="element-400">
            1 compra impulsiva menos por día = $150–$300 recuperados por mes.
          </p>
        </div>
      </div>
    </section>;
}